/* Theme-local presentation only. No global Rebuy settings or cart requests. */
(() => {
  // Local runtime formatting: preserve cents in subscription/bundle prices.
  // This does not change the store's or Rebuy Admin's money settings.
  const preserveCents = () => {
    const shop = window.Rebuy?.shop;
    if (typeof shop?.money_format !== 'string') return;
    shop.money_format = shop.money_format
      .replace('amount_no_decimals_with_comma_separator', 'amount_with_comma_separator')
      .replace('amount_no_decimals', 'amount');
  };
  document.addEventListener('rebuy.loaded', preserveCents);
  document.addEventListener('rebuy:smartcart.init', preserveCents);
  preserveCents();
  const attach = () => {
    preserveCents();
    const cart = document.getElementById('rebuy-cart');
    if (!cart || cart.dataset.caeneMyCart) return;
    cart.dataset.caeneMyCart = 'true';
    const setText = (selector, value) => {
      const node = cart.querySelector(selector);
      if (node && node.textContent !== value) node.textContent = value;
    };
    // Use Rebuy's own per-tier calculation, preserving exclusions, discounts,
    // currency conversion and subscription shipping rules. No thresholds stored here.
    const syncTierLabels = () => {
      const smartCart = window.Rebuy?.SmartCart;
      const tiers = smartCart?.progressBar?.tiers;
      const labels = cart.querySelectorAll('.rebuy-cart__progress-step-label');
      if (!tiers || typeof smartCart.getSpendToNextTier !== 'function' ||
          typeof smartCart.progressTierReached !== 'function') return;
      const currency = smartCart.currency();
      const precision = new Intl.NumberFormat('en', {style: 'currency', currency})
        .resolvedOptions().maximumFractionDigits;
      const numbers = new Intl.NumberFormat('en', {maximumFractionDigits: precision});
      tiers.forEach((tier, index) => {
        if (!labels[index] || !['shipping', 'product'].includes(tier.type)) return;
        // Non-monetary reward tiers keep their native labels.
        if (tier.unlock_condition_type === 'item_quantity') return;
        const reward = tier.type === 'shipping' ? 'free shipping' : 'free gift';
        const reached = smartCart.progressTierReached(tier);
        const remaining = smartCart.getSpendToNextTier({...smartCart.progressBar, tiers: [tier]});
        if (!Number.isFinite(remaining)) return;
        const amount = numbers.format(Math.max(0, remaining) / (10 ** precision));
        const value = reached ? `${reward[0].toUpperCase()}${reward.slice(1)} unlocked`
          : `${amount} ${currency} to ${reward}`;
        if (labels[index].textContent !== value) labels[index].textContent = value;
      });
    };
    const sync = () => {
      syncTierLabels();
      setText('#rebuy-cart-title', 'My cart');
      const progress = cart.querySelector('[data-rebuy-component="progress-bar"]');
      if (progress && !cart.querySelector('.caene-cart-intro')) {
        const intro = document.createElement('p');
        intro.className = 'caene-cart-intro';
        intro.textContent = 'GREAT CHOICE, YOU WILL LOVE IT';
        progress.before(intro);
      }

      setText('.rebuy-cart__flyout-empty-cart h4', 'Your cart is empty.');
      setText('.rebuy-cart__flyout-empty-cart a', 'Continue browsing');
      setText('[data-rebuy-id="288816"] .super-title', 'Complete your routine');
      const checkout = cart.querySelector('.rebuy-cart__checkout-button');
      if (checkout) {
        for (const [name, position] of [['shipping', 'before'], ['payments', 'after']]) {
          const selector = `.caene-cart-${name}`;
          const id = name === 'payments' ? 'payment' : name;
          const template = document.getElementById(`caene-cart-${id}-template`);
          if (template && !cart.querySelector(selector)) {
            const content = template.content.cloneNode(true);
            checkout[position](content);
          }
        }
      }

    };
    cart.addEventListener('click', (event) => {
      if (!event.target.closest('.rebuy-cart__flyout-empty-cart a')) return;
      const close = cart.querySelector('#rebuy-cart-close');
      if (!close) return;
      event.preventDefault();
      event.stopPropagation();
      close.click();
    }, true);
    new MutationObserver(sync).observe(cart, {subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'style']});
    sync();
  };
  document.addEventListener('rebuy:smartcart.ready', attach);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, {once: true});
  attach();
})();
